module.exports = __webpack_public_path__ + "img/breath_blue.9b5e67d1.png";